import type { LiveSample } from '@kontor/shared'
import { create } from 'zustand'

interface MetricStore {
  /** The newest sample per server, for the tiles on the overview. */
  samples: Record<string, LiveSample>
  apply: (sample: LiveSample) => void
  clear: () => void
}

export const useMetricStore = create<MetricStore>((set) => ({
  samples: {},
  apply: (sample) => set((store) => ({ samples: { ...store.samples, [sample.serverId]: sample } })),
  clear: () => set({ samples: {} }),
}))
